import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import {
  Box,
  Button,
  Drawer,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import  from "../../../../components/CustomModal/CustomModal";
// import CustomButton from "../../../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { AppColors } from "../../../../util/AppColors";

// Import actions
import CustomSwitch from "../../../../components/CustomSwitch";
import {
  createDevice,
  deleteDevice,
  getDevices,
  updateDevice,
} from "../../../../redux/reducers/deviceSlice";

function Devices() {
  const dispatch = useDispatch();
  const { devices, loading } = useSelector((state) => state.device);
  const [delModVisible, setDelModVisible] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const [form, setForm] = useState({ name: "" });
  const [editForm, setEditForm] = useState({ name: "" });

  useEffect(() => {
    dispatch(getDevices());
  }, [dispatch]);

  const handleDelModClose = () => {
    setDelModVisible(false);
    setDeleteIndex(null);
  };

  const handleDelConfirm = () => {
    const facilityId = devices[deleteIndex].facilityId;
    dispatch(deleteDevice(facilityId)).then(() => {
      handleDelModClose();
    });
  };

  const handleEdit = (index) => {
    const selectedDevice = devices[index];
    setForm({ name: selectedDevice.name });
    setEditIndex(index);
    setOpenDrawer(true);
  };

  const handleAdd = () => {
    dispatch(createDevice({ name: form.name, type: "Devices" })).then(() => {
      dispatch(getDevices());
      setForm({ name: "" });
      setEditIndex(null);
      setOpenDrawer(false);
    });
  };

  const handleUpdate = () => {
    const facilityId = devices[editIndex].facilityId;
    dispatch(
      updateDevice({
        id: facilityId,
        name: form.name,
        type: "Devices",
      })
    ).then(() => {
      dispatch(getDevices());
      setForm({ name: "" });
      setEditIndex(null);
      setOpenDrawer(false);
    });
  };

  const handleDelete = (index) => {
    const facilityId = devices[index].facilityId;
    dispatch(deleteDevice(facilityId));
  };

  const filteredRows = devices.filter((row) =>
    row.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleChangeSwitch = (status, device) => {
    dispatch(
      updateDevice({
        id: device?.facilityId,
        name: device?.name,
        type: "Devices",
        status,
      })
    ).then((res) => {
      if (res?.payload) dispatch(getDevices());
    });
  };

  return (
    <Box p={3}>
      {/* Top section */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={2}
        flexWrap="wrap"
      >
        <Box display="flex" gap={2} mx="auto" mb={2}>
          <TextField
            label="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ width: "500px", backgroundColor: AppColors.lightPink }}
          />
          <Button variant="contained" onClick={() => setOpenDrawer(true)}>
            Create
          </Button>
        </Box>
        <Typography variant="h6" sx={{ ml: "auto" }}>
          Total Devices: {filteredRows.length}
        </Typography>
      </Box>

      {/* Table */}
      <TableContainer component={Paper} sx={{ mt: 2 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>S.No</TableCell>
              <TableCell>Device Name</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Created By</TableCell>
              <TableCell>Created Date</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : filteredRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No records found
                </TableCell>
              </TableRow>
            ) : (
              filteredRows.map((row, index) => (
                <TableRow key={row.facilityId}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.name}</TableCell>
                  <TableCell>
                    <div>
                      <div>
                        <CustomSwitch
                          value={row?.status}
                          onChange={(e) =>
                            handleChangeSwitch(e?.target?.value, row)
                          }
                          greenToRed
                        />
                      </div>
                      <div>{row?.status ? "Active" : "Under Maintenance"}</div>
                    </div>
                  </TableCell>
                  <TableCell>{row.userName || "-"}</TableCell>
                  <TableCell>
                    {new Date(row.createdDate).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      size="small"
                      onClick={() => handleEdit(index)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      color="error"
                      size="small"
                      onClick={() => {
                        setDeleteIndex(index);
                        setDelModVisible(true);
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Drawer for adding new device */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
      >
        <Box p={3} width={300}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" color="primary">
              {editIndex !== null ? "Edit Device" : "Create Device"}
            </Typography>
            <IconButton onClick={() => setOpenDrawer(false)} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
          <TextField
            fullWidth
            label="Device Name"
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            margin="normal"
            InputLabelProps={{
              sx: {
                position: "absolute",
                top: "50%",
                left: "14px",
                transform: "translateY(-50%)",
                transition: "all 0.2s ease-out",
                "&.Mui-focused, &.MuiFormLabel-filled": {
                  top: "0px",
                  transform: "translateY(-50%) scale(0.75)",
                  transformOrigin: "top left",
                },
              },
            }}
          />
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={editIndex !== null ? handleUpdate : handleAdd}
          >
            {editIndex !== null ? "Update" : "Add"}
          </Button>
        </Box>
      </Drawer>

      {/* Edit Dialog */}
      <CustomModal
        open={delModVisible}
        onClose={handleDelModClose}
        header="Delete"
        modal
        modalWidth={30}
      >
        <Typography className="flex-center txt-regular fs14">
          Are you sure you want to delete this record?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleDelModClose} />
          </div>
          <div className="ml10">
            <CustomButton redBtn text="Confirm" onClick={handleDelConfirm} />
          </div>
        </div>
      </CustomModal>
    </Box>
  );
}

export default Devices;
